<template>
  <div class="body">
    <div class="bg-white p20 pb50">
      <el-breadcrumb separator="/" class="mb20">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/examination/examStatistics' }">考试统计</el-breadcrumb-item>
        <el-breadcrumb-item>考试统计详情</el-breadcrumb-item>
      </el-breadcrumb>
      <el-table
        class="mb20"
        v-loading="loading"
        :data="tableData"
        style="width: 100%"
      >
        <el-table-column label="序号" type="index" width="60"></el-table-column>
        <el-table-column label="考试人员" prop="userName"></el-table-column>
        <el-table-column label="所属部门" prop="deptName"></el-table-column>
        <el-table-column label="分数" prop="score"></el-table-column>
        <el-table-column label="考试结果" prop="psddStuts">
          <template slot-scope="scope">
            <div v-if="scope.row.examStatus == 0">
              <el-tag v-if="scope.row.psddStuts == 0" type="success"
                >合格</el-tag
              >
              <el-tag v-else type="danger">不合格</el-tag>
            </div>
            <div v-else>
              <el-tag type="danger">未参加</el-tag>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="操作">
          <template slot-scope="scope" v-if="scope.row.examStatus == 0">
            <el-button
              size="mini"
              type="success"
              @click="
                $router.push(
                  `/student/lookExam?id=${scope.row.paperId}&examDetailListId=${scope.row.examDetailId}&name=${scope.row.userName}`
                )
              "
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="float:right;"
        background
        layout="total ,prev, pager, next"
        :total="total"
        :page-size="listParams.pageSize"
        @current-change="pageChange"
      ></el-pagination>

      <el-button type="primary" @click="exportFile">导出</el-button>
    </div>
  </div>
</template>

<script>
import exam from "../../api/new/exam.js";
import util from '@/common/util';
export default {
  data() {
    return {
      questionTypeList: [], // 题型列表
      tableData: [],

      listParams: {
        page: 1,
        pageSize: 10
        // examId: "",
        // examName: "",
        // date: "",
        // examType: ""
      },
      total: 0,
      loading: true,
      departmentList: []
    };
  },
  mounted() {
    this.listParams.examId = this.$route.query.id;
    this.trainingStatisticsListDetail();
    this.departmentList = JSON.parse(localStorage.getItem("departmentList"));
  },
  methods: {
    trainingStatisticsListDetail() {
      let listParams = { ...this.listParams };
      // !listParams.examName && delete listParams.examName;
      // !listParams.examType && delete listParams.examType;
      exam.trainingStatisticsListDetail(listParams).then(res => {
        if (res.code == 0) {
          this.tableData = res.data.records;
          this.total = res.data.total;
          this.loading = false;
        } else {
          this.loading = false;
          this.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        }
      });
    },
    pageChange(e) {
      this.listParams.page = e;
      this.trainingStatisticsListDetail();
    },
    search() {
      this.listParams.page = 1;
      this.trainingStatisticsListDetail();
    },

    /**
     * 重置表单
     */
    resetForm(formName) {
      this.$nextTick(() => {
        this.$refs[formName].resetFields();
      });
    },
    exportFile(){
      exam.trainingDetailExport({
        examId:this.$route.query.id
      }).then(res=>{
        util.downloadBlobFile(res,"考试统计.xls");
      })
    },
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/examination/examStatisticsDetail.vue